/* -------------------------------------------------------------------------- */
/*                               Project types                                */
/* -------------------------------------------------------------------------- */

import { PROJECT_TECHNOLOGIES } from '@config/constants/project-technologies';

/**
 * Retrieves the label associated with the specified technology ID.
 * @param {string} id - The ID of the technology to retrieve the label for.
 * @returns {string|null} The label of the technology, or null if the technology is not found.
 */
export const getTechnologyProject = (
	_technology: string
) => {
	const foundTechnology = PROJECT_TECHNOLOGIES.find(
		(technology) => technology.value === _technology
	);
	return (
		foundTechnology ||
		PROJECT_TECHNOLOGIES.find(
			(technology) => technology.value == 'UNSPECIFIED'
		)
	);
};
